import { render, staticRenderFns } from "./ManagingTotalRevenue.vue?vue&type=template&id=07ca2a72&scoped=true"
import script from "./ManagingTotalRevenue.vue?vue&type=script&lang=js"
export * from "./ManagingTotalRevenue.vue?vue&type=script&lang=js"
import style0 from "./ManagingTotalRevenue.vue?vue&type=style&index=0&id=07ca2a72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ca2a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ca2a72')) {
      api.createRecord('07ca2a72', component.options)
    } else {
      api.reload('07ca2a72', component.options)
    }
    module.hot.accept("./ManagingTotalRevenue.vue?vue&type=template&id=07ca2a72&scoped=true", function () {
      api.rerender('07ca2a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingTotalRevenue.vue"
export default component.exports